/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'virtual-service-faults';
const prefix = `${moduleName}.${componentName}`;

export const virtualServiceFaultDetectedPlural = `${prefix}.virtualServiceFaultDetectedPlural`;
export const serviceEngineFaultDetectedPlural = `${prefix}.serviceEngineFaultDetectedPlural`;
export const serverFaultsLabel = `${prefix}.serverFaultsLabel`;

export const ENGLISH = {
    [virtualServiceFaultDetectedPlural]: '{0, plural, one{# Virtual Service fault detected} other{# Virtual Service faults detected}}',
    [serviceEngineFaultDetectedPlural]: '{0, plural, one{# Service Engine fault detected} other{# Service Engine faults detected}}',
    [serverFaultsLabel]: 'Server Faults',
};
